export default {
  noData: 'No events were found for the current filter criteria.',
};
